export default "__VITE_ASSET__VW8c4tuB__"